import React from 'react';
import Authenticated from '@/Layouts/Authenticated';
import { Head } from '@inertiajs/inertia-react';

export default function Validator({auth, store, is_validator, ...props}) {
    const getLabelRoleName = (role) => {
        if (role.name === 'cashbox') return 'validador de caja';
        if (role.name === 'validator') return 'validador de pista';
        if (role.name === 'admin') return 'administrador de sucursales';
        if (role.name === 'super_admin') return 'super administrador'
    }

    const getMessage = () => {
        if (auth.user.roles.length === 1) {
            return `Haz iniciado sesión como un ${getLabelRoleName(auth.user.roles[0])}`
        } else if (auth.user.roles.length === 2) {
            return `Haz iniciado sesión como un ${getLabelRoleName(auth.user.roles[0])} y como un ${getLabelRoleName(auth.user.roles[1])}`
        } else if (auth.user.roles.length > 2) {
            const firstRole = auth.user.roles[0];
            const lastRole = auth.user.roles[-1];

            const mediumRoles = auth.user.roles.filter(role => role.name !== firstRole.name && role.name !== lastRole.name);
            const textMediumRoles = mediumRoles.map(role => (`, como un ${getLabelRoleName(role)}`)).join('');

            return `Haz iniciado sesión como un ${getLabelRoleName(firstRole)}${textMediumRoles}, y como un ${getLabelRoleName(lastRole)}`
        }

        return 'No tienes roles.'
    }

    return (
        <Authenticated
            store={store}
            auth={auth}
            errors={props.errors}
            isValidator={is_validator}
        >
            <Head title="Dashboard" />

            <div className="py-12">
                <div className="flex justify-center items-center max-w-7xl mx-auto sm:px-6 lg:px-8">
                    <div className="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div className="p-6 bg-white border-b border-gray-200">
                            <h2 className="text-xl font-bold text-center mb-4 max-w-md">{(getMessage)()}</h2>
                            <p className="text-center mb-4">En la sucursal <b>{auth.user?.branch_office?.name}</b></p>
                            {/* <div className="w-full flex justify-center items-center">
                                <button onClick={handleCloseWindow} className="px-3 py-2 bg-primary text-white rounded text-sm">Cerrar ventana</button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </Authenticated>
    );
}
